
import { Component, Prop, Vue } from "vue-property-decorator";

import REMOVE_EXPERIENCE from "@/apollo/profile/experiences/RemoveExperience.gql";

import CardItem from "@/components/profile/common/CardItem.vue";
import CardContainer from "@/components/profile/common/CardContainerNew.vue";
import ExperienceForm from "@/components/profile/experiences/ExperienceForm.vue";

import { User_Experience } from "@/generated/graphql";
import { Moment } from 'moment';
import { NOTIFICATION } from "@/entities/Events";
import Message from '@/data/notificationsMessages';
import { Maybe } from "graphql/jsutils/Maybe";

@Component({
    components: {
        CardItem,
        CardContainer,
        ExperienceForm,
    }
}
)
export default class ExperienceCard extends Vue {
    @Prop({ type: Object, required: true }) readonly experience!: User_Experience;
    @Prop({ type: String, required: true }) readonly userId!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;

    isModalOpen: boolean = false;

    get companyName(): Maybe<string> | undefined {
        return this.experience?.company_name;
    }

    get jobTitle(): Maybe<string> | undefined {
        return this.experience?.job_title;
    }

    get startDate(): string | undefined {
        if (this.experience?.start_date) {
            const startDate = this.$moment(this.experience?.start_date) as unknown as Moment;
            return startDate.format("DD MMM, YYYY")
        }

        return undefined;
    }

    get endDate(): string | undefined {
        if (this.experience.ongoing) {
            return "Ongoing";
        }

        if (this.experience?.end_date) {
            const endDate = this.$moment(this.experience?.end_date) as unknown as Moment;
            return endDate.format("DD MMM, YYYY")
        }

        return undefined;
    }

    get location(): Maybe<string> | undefined {
        return this.experience.location;
    }

    get industry(): Maybe<string> | undefined {
        return this.experience.industry?.name;
    }

    get skills(): string | undefined {
        return this.experience.skills
            .map(({ skill }) => skill.name)
            .join(", ") || undefined;
    }

    toggleModal(): void {
        this.isModalOpen = !this.isModalOpen;
    }

    async removeExperience(): Promise<void> {
        try {
            await this.remove();
            this.$emit("removed");

            this.$eventBus.emit(
                NOTIFICATION,
                Message.successMessage(`${this.experience.company_name !== "" ? this.experience.company_name : "Selected"}  is removed from your experience.`)
            );
        } catch (error) {
            var msg = "";
            if (error instanceof Error) {
                msg = error.message;
            } else {
                msg = error as string;
            }
            this.$eventBus.emit(
                NOTIFICATION,
                Message.errorMessage(msg)
            );
        }
    }

    async remove(): Promise<void> {
        await this.$apollo.mutate({
            mutation: REMOVE_EXPERIENCE,
            variables: {
                id: this.experience.id,
            },
        });
    }
}
